import { render, staticRenderFns } from "./PaymentStatusBadge.vue?vue&type=template&id=07986af8&scoped=true"
import script from "./PaymentStatusBadge.vue?vue&type=script&lang=js"
export * from "./PaymentStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./PaymentStatusBadge.vue?vue&type=style&index=0&id=07986af8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07986af8",
  null
  
)

export default component.exports